/* eslint-disable @trello/filename-case */
import { Row } from 'react-table';
import { RowData } from 'app/src/components/BoardTableView/types';
import moment from 'moment';

export const sorters = {
  due: (rowA: Row<RowData>, rowB: Row<RowData>, _id: string, desc: boolean) => {
    const dueA = rowA.original.due;
    const dueB = rowB.original.due;

    if (dueA === null) {
      return desc ? -1 : 1;
    }

    if (dueB === null) {
      return desc ? 1 : -1;
    }

    return moment(dueA).diff(moment(dueB));
  },
};
